import React, { PropsWithChildren, ReactElement, useContext } from 'react';

import { LogDataFormGroupProps, UnitNode } from '../../components';

export interface StickyTabContextValue {
  /** 로그 데이터를 custom할 때 사용합니다. */
  setLogData?: (unitNode?: UnitNode) => LogDataFormGroupProps;
}

const StickyTabContext = React.createContext<StickyTabContextValue>({});
export const useStickyTabContext = (): StickyTabContextValue => useContext(StickyTabContext);

export function StickyTabContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: StickyTabContextValue }>): ReactElement {
  return (
    <StickyTabContext.Provider value={value}>{ children }</StickyTabContext.Provider>
  );
}
